import { jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useFlowState, track } from "@betterment/js-runtime";
import { S as SuccessOverlay } from "./SuccessOverlay-DjKS2rlN.js";
import { c as navigate } from "./index-BEglnXN9.js";
const gtmTrack = (eventName, options = {}) => {
  if (window.dataLayer) {
    window.dataLayer.push({ event: eventName, ...options });
  }
};
const SuccessStep = ({
  message,
  redirectTo,
  onSuccess,
  eventProperties,
  gtmProperties
}) => {
  const {
    flowState: { returnToPath }
  } = useFlowState();
  const navigateCompleted = () => {
    if (onSuccess) {
      onSuccess();
    } else {
      navigate(redirectTo || returnToPath);
    }
  };
  useEffect(() => {
    if (eventProperties) {
      track("ElementViewed", eventProperties);
    }
    if (gtmProperties) {
      gtmTrack(gtmProperties);
    }
  }, [eventProperties, gtmProperties]);
  return /* @__PURE__ */ jsx(SuccessOverlay, { message, onCompletion: navigateCompleted });
};
export {
  SuccessStep as S,
  gtmTrack as g
};
//# sourceMappingURL=SuccessStep-BlttH52e.js.map
